"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faBoxFull = require("@fortawesome/pro-regular-svg-icons/faBoxFull");

var _excluded = ["state"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center w-full py-10"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faBoxFull.faBoxFull,
    size: "6x"
  }));
};

var PanelsContent = function PanelsContent(_ref) {
  var _window, _window$location;

  var flipped = _ref.flipped,
      largePanelImage = _ref.largePanelImage,
      largePanelImageAlt = _ref.largePanelImageAlt,
      largePanelImageLink = _ref.largePanelImageLink,
      largePanelImageLinkExternal = _ref.largePanelImageLinkExternal,
      smallPanelImageTop = _ref.smallPanelImageTop,
      smallPanelImageTopAlt = _ref.smallPanelImageTopAlt,
      smallPanelImageTopLink = _ref.smallPanelImageTopLink,
      smallPanelImageTopLinkExternal = _ref.smallPanelImageTopLinkExternal,
      smallPanelImageBottom = _ref.smallPanelImageBottom,
      smallPanelImageBottomAlt = _ref.smallPanelImageBottomAlt,
      smallPanelImageBottomLink = _ref.smallPanelImageBottomLink,
      smallPanelImageBottomLinkExternal = _ref.smallPanelImageBottomLinkExternal;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container grid grid-cols-1 gap-[15px] lg:grid-cols-6 lg:gap-[30px] ".concat(flipped ? 'lg:flex-row-reverse' : '')
  }, /*#__PURE__*/_react["default"].createElement("a", _extends({
    href: largePanelImageLink,
    className: "lg:col-span-4 w-full h-full"
  }, !inStorefront && {
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, largePanelImageLinkExternal && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: largePanelImage,
    alt: largePanelImageAlt,
    className: "w-full h-full"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "lg:col-span-2 flex flex-col gap-y-[15px] lg:gap-y-[30px] ".concat(flipped ? 'order-first' : '')
  }, /*#__PURE__*/_react["default"].createElement("a", _extends({
    href: smallPanelImageTopLink,
    className: "lg:col-span-4 w-full h-full"
  }, !inStorefront && {
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, smallPanelImageTopLinkExternal && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: smallPanelImageTop,
    alt: smallPanelImageTopAlt,
    className: "w-full h-full"
  })), /*#__PURE__*/_react["default"].createElement("a", _extends({
    href: smallPanelImageBottomLink,
    className: "lg:col-span-4 w-full h-full"
  }, !inStorefront && {
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, smallPanelImageBottomLinkExternal && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: smallPanelImageBottom,
    alt: smallPanelImageBottomAlt,
    className: "w-full h-full"
  })))));
};

var PanelsRenderer = function PanelsRenderer(_ref2) {
  var state = _ref2.state,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(PanelsContent, _extends({}, state, props));
};

var _default = PanelsRenderer;
exports["default"] = _default;